import { useCallback, useState } from "react";

import { deleteProjectUserAccess } from "Api/userAccess/deleteProjectUserAccess.request";

import { useListUserAccessesByProjectId } from "./useListUserAccessesByProjectId";

export const useDeleteProjectUserAccess = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<unknown>();
  const [, , , loadUserAccesses] = useListUserAccessesByProjectId();

  const action = useCallback(
    async (projectId: string, userId: string) => {
      setIsLoading(true);
      try {
        await deleteProjectUserAccess(projectId, userId);
        loadUserAccesses();
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    },
    [loadUserAccesses]
  );

  return [action, isLoading, error] as const;
};
